export default {
  install(Vue, options) {
    if (!window._hmt) {
      window._hmt = [];
      const hm = document.createElement('script');
       hm.src = "https://hm.baidu.com/hm.js?3eb6e2f5e6435a91154828fac6e90634";
      document.body.appendChild(hm);
    }
  }
}